import {
  LiveSolid,
  VideoSolid,
} from "@lazarentertainment/web-design-system/components/iconSolid"
import { useChannelContext } from "client/components/channel"
import { Badge } from "client/designSystem/Badge"

export const VideoBadge = () => {
  const { recordingId, live } = useChannelContext()
  if (recordingId) {
    return (
      <Badge variant="overlay" icon={VideoSolid}>
        Replay
      </Badge>
    )
  }
  if (live) {
    return (
      <Badge variant="rose" icon={LiveSolid}>
        Live
      </Badge>
    )
  }
  return <Badge variant="overlay">Offline</Badge>
}
